/**
 * Keep order lookup credentials and proof tokens out of analytics, without
 * changing navigation.
 *
 * Sensitive query params are stripped on every path (defence in depth), and
 * sensitive pages (`/track-order`, `/thank-you`, including `/ar/…` and
 * `/en/…` prefixes) also lose their hash fragment.
 */

/** تُحذف من أيّ رابط: تكشف هويّة العميل مباشرةً. */
const ALWAYS_STRIPPED = new Set(["email", "phone", "last4", "order", "order_id"]);

/** أسماء عامّة (t/token/key/sig): تُحذف على المسارات الحسّاسة فقط. */
const PROOF_PARAMS = new Set(["t", "token", "key", "sig"]);

const SENSITIVE_PATH_RE = /^(?:\/(?:ar|en|fr))?\/(?:track-order|thank-you)\/?$/i;

/** هل هذا مسار حسّاس (إثبات ملكيّة طلب في الرابط)؟ */
export function isSensitiveAnalyticsPath(pathname: string): boolean {
  return SENSITIVE_PATH_RE.test(pathname);
}


export function analyticsUrl(value: string): string {
  if (!value) return value;
  try {
    const url = new URL(value, "https://analytics.invalid");
    if (!/^https?:$/.test(url.protocol)) return "";
    const sensitivePath = isSensitiveAnalyticsPath(url.pathname);
    let changed = false;
    for (const key of [...url.searchParams.keys()]) {
      const k = key.toLowerCase();
      if (ALWAYS_STRIPPED.has(k) || (sensitivePath && PROOF_PARAMS.has(k))) {
        url.searchParams.delete(key);
        changed = true;
      }
    }

    if (!sensitivePath && !changed) return value;
    if (sensitivePath) url.hash = "";
    return /^https?:\/\//i.test(value)
      ? url.href
      : value.startsWith("//")
        ? `//${url.host}${url.pathname}${url.search}${url.hash}`
        : `${url.pathname}${url.search}${url.hash}`;
  } catch {
    // An unparseable URL is not useful analytics and may still contain a secret.
    return "";
  }
}
